import { cloneDeep, clone } from "lodash"
import { ElMessage } from 'element-plus'
import exportToExcel from "@/utlis/exportToExcel";

export const pageMixin = {
    data() {
        return {
            pageSearch: {
                // 使用方拓展定义
            },
            // 分页数据
            pageInfo: {
                currentPage: 1,
                pageSize: 15,
                pageSizeArr: [15, 20, 30],
                total: 0,
                loading: false
            },
            // 表格列表
            pageData: [],
            // 接口
            pageApi: {
                list: null,
                del: null,
                add: null,
                update: null,
                find: null
            },
            // ext
            outerVisible: false,
            initFormData: {},
            formData: {},
            rules: {},
            aForm: null,
            isFirstTimeMounted: true,
            // 最大导出数
            maxExportNum: 9999,
        };
    },
    mounted() {
        if (this.isFirstTimeMounted) {
            this.handlePageInit();
        }
    },
    methods: {
        /**
         * 初始化
         */
        async handlePageInit() {
            console.log('初始化了', this.pageSearch);
            await this.handlePageLoad();
            this.isFirstTimeMounted = false; // 调用后，将标志设置为false
        },

        /**
         * 获取列表
         * page 当前页  all全部数据
         */
        async handlePageLoad(option = {
            type: "page",
        }) {
            if (!this.pageApi.list) {
                console.error("未配置 pageApi.list")
                return
            }
            if (this.pageSearch){

                this.pageSearch.isPlanCar = this.$route.query?.isPlanCar;
            }else {
                this.pageSearch = {
                    isPlanCar: this.$route.query?.isPlanCar,
                }
            }
            console.log('初始化了pageSearch', this.pageSearch);
            this.pageInfo.loading = true;
            let data = {}
            if (option.type == "page") {
                data = {
                    currentPage: this.pageInfo.currentPage,
                    pageSize: this.pageInfo.pageSize,
                    ...this.pageSearch,
                }
            } else if (option.type == 'all') {
                data = {
                    currentPage: this.pageInfo.currentPage,
                    pageSize: this.maxExportNum,
                    ...this.pageSearch,
                }
            }
            let res = await this.pageApi.list({
                ...data
            })
            if (res.success) {
                if (res.hasOwnProperty('entity')) {
                    // 存在 entity 属性
                    this.pageData = res.entity.list;
                    this.pageInfo.total = res.entity.total
                } else {
                    // 不存在 entity 属性
                    this.pageData = res.pageInfo.list
                    this.pageInfo.total = res.pageInfo.total
                }
                if (option.type == 'all') {
                    // 成功以后重新加载列表
                    this.handlePageLoad();
                }
                this.pageInfo.loading = false;
                return { code: true, list: this.pageData }
            } else {
                this.pageInfo.loading = false;
                return false
            }

        },
        handlePageSizeChange(size) {
            this.pageInfo.currentPage = 1;
            this.pageInfo.pageSize = size;
            this.pageInfo.total = 0;
            this.handlePageLoad();
        },
        async handleOpenModal(_row = null) {
            if (_row) {
                let row = _row;
                if (this.pageApi.find) {
                    let res = await this.pageApi.find({ id: row.id })
                    if (res.success) {
                        row = res.entity;
                    }
                }
                let obj = {};
                for (let key in this.initFormData) {
                    if (row[key] != undefined) {
                        obj[key] = clone(row[key]);
                    }
                }
                if (row['id']) {
                    obj['id'] = clone(row['id']);
                }
                this.formData = obj

            } else {
                this.formData = clone(this.initFormData);
            }
            this.outerVisible = true;
        },
        handleCurrentChange(page) {
            this.pageInfo.currentPage = page;
            this.handlePageLoad();
        },
        handleResetForm(formName) {
            this.$refs[formName].resetFields();
        },
        handleSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.handleSave(this.formData)
                } else {
                    return false;
                }
            });
        },
        async handleSave(row) {
            let apifunc = this.pageApi.add;
            if (row.id) {
                apifunc = this.pageApi.update
            }
            if (!apifunc) {
                console.error("pageApi add update 未正确配置")
                return;
            }
            let res = await apifunc(row);
            if (res.success) {
                this.handlePageInit();
                this.outerVisible = false;
                ElMessage({
                    message: res.message,
                    type: 'success',
                })
            } else {
                return false;
            }

        },
        handleRemove(row, key = 'ids') {
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res
                if (!this.pageApi.del) {
                    console.error("pageApi del 未正确配置")
                    return;
                }
                if (row.id) {
                    res = await this.pageApi.del({ [key]: row.id })
                } else {
                    res = await this.pageApi.del({ [key]: row.join(',') })
                }
                if (res.success) {
                    ElMessage({
                        message: res.message,
                        type: 'success',
                    })
                    this.handlePageInit();
                    this.outerVisible = false;
                }
            })
        },


        handleupdate(row) {
            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: '提醒'
            }).then(async () => {
                if (!this.pageApi.del) {
                    console.error("pageApi del 未正确配置")
                    return;
                }
                let res = await this.pageApi.del({ carId: row.id })
                if (res.success) {
                    ElMessage({
                        message: res.message,
                        type: 'success',
                    })
                    this.handlePageInit();
                    this.outerVisible = false;
                }
            })
        }
    },
}
